<template>
  <view>
    <view>min-height 属性最小内容展示高度</view>
    <view class="bg-white">
      <cube-collapse min-height="{{ '40px' }}">
        <view class="text">内容文案，第一行</view>
        <view class="text">内容文案，第二行</view>
        <view class="text">内容文案，第三行</view>
        <view class="text">内容文案，第四行</view>
        <view class="text">内容文案，第五行</view>
        <view class="text">内容文案，第六行</view>
        <view class="text">内容文案，第七行</view>
      </cube-collapse>
    </view>

    <view class="item">内容小于 min-height时，隐藏展开按钮 </view>
    <view class="bg-white">
      <cube-collapse min-height="{{ '100px' }}">
        <view class="text">内容文案，第一行</view>
        <view class="text">内容文案，第二行</view>
        <view class="text">内容文案，第三行</view>
      </cube-collapse>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    switchText: ['可以展示查看新内容', '收起内容']
  }
})
</script>

<style lang="stylus" scoped>
.bg-white
  margin-top: 6px
  background-color: #fff
.text
  line-height: 20px
.item
  margin-top: 20px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-collapse": "@mpxjs/mpx-cube-ui/src/components/collapse/index"
    }
  }
</script>
